<template>
    <div>
        <Slideshow :length="pages.length" v-model:slide="slide" v-if="pages.length > 0" class="gmf-context gmf-p-0">
            <div
                v-for="(page, index) in pages"
                :key="index"
                class="gmf-category-product-recommendation-wrap gmf-slideshow-slide gmf-active"
                :class="{ 'gmf-active': index === slide }"
                :style="`grid-template-columns: repeat(${itemsPerPage}, minmax(0, 1fr));`"
            >
                <Link v-for="comment in page" :key="comment.id" :href="commentUrl(comment)">
                <Comment :comment="comment" voteMode="none" :collapse="true" :hideReplies="true" :elements="elements"
                    :disableTargetLink="true" />
                </Link>
            </div>
        </Slideshow>
        <div class="gmf-center" v-if="pages.length > 1">
            <NavDots :count="pages.length" :modelValue="slide" @update:modelValue="v => slide = v" />
        </div>
    </div>
</template>

<style>
.gmf-category-product-recommendation-wrap {
    display: grid;
    gap: var(--gmf-p-5);
    align-items: center;
}

.gmf-category-product-recommendation-wrap .gmf-comment-customer-col {
    width: 80px !important;
    justify-content: center;
}

.gmf-category-product-recommendation-wrap .gmf-comment-header {
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    flex-grow: 0;
    flex-shrink: 1;
}
.gmf-category-product-recommendation-wrap .gmf-comment-content {
    display: flex !important;
}

.gmf-category-product-recommendation-wrap a {
    text-decoration: none;
}
</style>

<script>
import elSize from '@/utils/mixins/elSize';
import callApi from '@/utils/callApi';

import Comment from '@/components/Comment';
import Link from '@/components/Link';
import NavDots from '@/components/NavDots';

import Slideshow from '@/components/Slideshow';

export default {
    components: {
        Comment,
        Slideshow,
        Link,
        NavDots,
    },
    mixins: [elSize],
    props: ['categoryId'],
    data() {
        return {
            comments: [],
            slide: 0,
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            const res = await callApi('GET', '/v2/client/product-recommendations/' + encodeURIComponent(this.categoryId));
            const data = await res.json();
            this.comments = data.products;
        },
        commentUrl(comment) {
            /*if (comment.type.name === 'social_post' || comment.type.name === 'marketplace') {
                return this.socialFeedUrl;
            }*/
            return comment.target.url;
        },
    },
    computed: {
        itemsPerPage () {
            const w = this.elSize.width;
            const minItemWidth = 350;

            return Math.min(3, Math.floor(w / minItemWidth));
        },
        pages () {
            const itemsPerPage = this.itemsPerPage;

            if (itemsPerPage === 0) {
                return [];
            }

            const pages = [];

            for (let i = 0; i < this.comments.length; i += itemsPerPage) {
                pages.push(this.comments.slice(i, i + itemsPerPage));
            }

            return pages;
        },
        elements() {
            return {
                footer: false,
                title: false,
                uploads: false,
                prosAndCons: false,
                action: true,
                productImage: true,
                targetImage: true,
                target: false,
                customerLevel: false,
                stem: false,
                animateAvatar: true,
                translateButton: false,
                date: false,
            };
        },
    },
    watch: {
        pages() {
            if (this.slide >= this.pages.length) {
                this.slide = 0;
            }
        },
    },
};
</script>